import script from "./ColorDropdownItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorDropdownItem.vue?vue&type=script&setup=true&lang=ts"

import "./ColorDropdownItem.vue?vue&type=style&index=0&id=4c6d9570&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6d9570"]])

export default __exports__